import { HeroLayout } from "../../../components/hero/components/heroLayout/heroLayout";
import { ReactElement } from "react";
import { blue, tutorGreen } from "../../../theme";
import { Ranking, WordTicker } from "../components";
import reactStringReplace from "react-string-replace";
import { Star01 } from "@untitled-ui/icons-react";
import { HeroCtaButton } from "./dynamicHeroCtaButtons";
import { getCmsIcon } from "@kunduz/utility-common";
import { DynamicHeroButtonItem } from "./dynamicHeroButtonItem";
// import { SpeculationRules } from "@kunduz/feature-website-common";
import styles from "./dynamicHero.module.scss";
import classNames from "classnames";

export const DynamicHero = (props: Props): ReactElement => {
  const gradientToUse = {
    student: styles.blueG,
    teacher: styles.greenG,
    school: styles.blueG,
    parent: styles.blueG,
  };

  const textGradientToUse = {
    student: "blue",
    teacher: "green",
    school: "blue",
    parent: "blue",
  };

  const primaryButtonColorToUse: Record<string, any> = {
    student: blue,
    teacher: tutorGreen,
    school: blue,
    parent: blue,
  };

  const BadgeIcon = getCmsIcon(props.badgeIcon);

  // function calculatePrerenderUrl() {
  //   const prerenderUrls: string[] = [];

  //   if (props.buttonItems) {
  //     props.buttonItems.forEach((item) => {
  //       prerenderUrls.push(item.url);
  //     });
  //   }

  //   props.primary_cta_url && prerenderUrls.push(props.primary_cta_url);
  //   props.secondary_cta_url && prerenderUrls.push(props.secondary_cta_url);

  //   return prerenderUrls;
  // }

  return (
    <>
      {/* <SpeculationRules prerender={calculatePrerenderUrl()} /> */}
      <HeroLayout imageUrl={props.image}>
        <div className={styles.headingAndCtas}>
          <div className={styles.top}>
            <div className={styles.headingWrapper}>
              {props.badgeText && (
                <div className={styles.badge}>
                  {props.badgeIcon && (
                    <BadgeIcon
                      viewBox="0 0 24 24"
                      color={primaryButtonColorToUse[props.profile][800]}
                    />
                  )}
                  <span className={classNames(gradientToUse[props.profile])}>
                    {props.badgeText}
                  </span>
                </div>
              )}

              <div className={styles.heading}>
                {props.title?.map((titleRow, i) => (
                  <div className={styles.headingText} key={`heading_line_${i}`}>
                    {props.gradientText ? (
                      reactStringReplace(
                        titleRow,
                        "__gradient_text__",
                        (match, i) => (
                          <span
                            key={`__gradient__${i}`}
                            className={classNames(gradientToUse[props.profile])}
                          >
                            {props.gradientText}
                          </span>
                        ),
                      )
                    ) : props.animatedText ? (
                      reactStringReplace(
                        titleRow,
                        "__animated_text__",
                        (match, i) => (
                          <WordTicker
                            key={`__gradient__${i}`}
                            words={props.animatedText || []}
                            gradientType={
                              textGradientToUse[props.profile] as any
                            }
                          />
                        ),
                      )
                    ) : (
                      <div className={styles.headingPlainText}>{titleRow}</div>
                    )}
                  </div>
                ))}
              </div>

              <div className={styles.subheading}>{props.description}</div>
            </div>
          </div>

          {props.buttonItems && props.buttonItems.length > 0 ? (
            <div
              style={{
                display: "flex",
                gap: 16,
                flexDirection: "column",
                width: "100%",
              }}
            >
              {props.buttonItemsTitle && (
                <p className={styles.buttonItemsTitle}>
                  {props.buttonItemsTitle}
                </p>
              )}

              <div className={styles.buttonItemsWrapper}>
                {props.buttonItems.map((item, i) => (
                  <DynamicHeroButtonItem key={i} item={item} />
                ))}
              </div>
            </div>
          ) : (
            <div className={styles.actions}>
              {props.secondary_cta_label && props.secondary_cta_url && (
                <HeroCtaButton
                  label={props.secondary_cta_label}
                  url={props.secondary_cta_url}
                  icon={props.secondary_cta_icon}
                  profile={props.profile}
                  target={props.secondary_cta_target}
                  type={props.secondary_cta_type}
                  shallow={props.secondary_cta_shallow}
                />
              )}
              {props.primary_cta_label && props.primary_cta_url && (
                <HeroCtaButton
                  label={props.primary_cta_label}
                  url={props.primary_cta_url}
                  icon={props.primary_cta_icon}
                  profile={props.profile}
                  target={props.primary_cta_target}
                  type={props.primary_cta_type}
                  shallow={props.primary_cta_shallow}
                />
              )}
            </div>
          )}
        </div>

        {(props.rating_star || props.rating_text) && (
          <div
            data-testid="social-validation"
            className={styles.socialValidation}
          >
            <div className={styles.starsRow}>
              {Array.from(Array(props.rating_star)).map((s, t) => (
                <Star01
                  key={`star_${t}`}
                  color="#FEC84B"
                  viewBox="0 0 24 24"
                  className={styles.star}
                />
              ))}
            </div>

            {props.rating_text && (
              <div className={styles.ratingText}>{props.rating_text}</div>
            )}
          </div>
        )}
        {props.rankingItems && props.rankingItems.length > 0 && (
          <div className={styles.rankings}>
            {props.rankingItems.map((r, i) => (
              <Ranking key={i}>
                <div
                  className={styles.ranking}
                  dangerouslySetInnerHTML={{ __html: r }}
                ></div>
              </Ranking>
            ))}
          </div>
        )}
      </HeroLayout>
    </>
  );
};

interface Props {
  title: string[];
  description: string;
  image: string;
  badgeText?: string;
  badgeIcon?: string;
  rating_star?: number;
  rating_text?: string;
  primary_cta_label?: string;
  primary_cta_url?: string;
  primary_cta_icon?: string;
  primary_cta_type?: string;
  primary_cta_target?: string;
  primary_cta_shallow?: boolean;
  secondary_cta_label?: string;
  secondary_cta_url?: string;
  secondary_cta_icon?: string;
  secondary_cta_type?: string;
  secondary_cta_target?: string;
  secondary_cta_shallow?: boolean;
  animatedText?: string[];
  gradientText?: string;
  rankingItems?: string[];
  profile: "student" | "teacher" | "school" | "parent";
  buttonItemsTitle?: string;
  buttonItems?: {
    label: string;
    url: string;
    type: "primary" | "secondary" | "tertiary" | "link";
    target: "_blank" | "_self" | "_parent" | "_top";
    order: number;
  }[];
}
